import { NgModule } from '@angular/core';
import { StoreModule } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';
import * as fromCustomerUsersState from './customer-users.reducer';
import { CustomerUsersEffects } from './customer-users.effects';

@NgModule({
	imports: [
		StoreModule.forFeature(
			fromCustomerUsersState.customerUsersFeatureKey,
			fromCustomerUsersState.reducer
		),
		EffectsModule.forFeature([CustomerUsersEffects]),
	],
})
export class CustomerUsersStateModule {}
